export const SCORING_TYPE_MAP = {
  longWords: "longWords",
  longSentences: "longSentences",
  veryLongSentences: "veryLongSentences",
  passives: "passives",
  grammarIssues: "grammarIssues",
  hiddenVerbs: "hiddenVerbs",
  adverbs: "adverbs",
  watchwords: "watchwords",
};

export const SCORING_TYPE_KEYS = Object.keys(SCORING_TYPE_MAP);

export const ISSUE_TYPE_ORDER = [
  SCORING_TYPE_MAP.veryLongSentences,
  SCORING_TYPE_MAP.longSentences,
  SCORING_TYPE_MAP.longWords,
  SCORING_TYPE_MAP.passives,
  SCORING_TYPE_MAP.hiddenVerbs,
  SCORING_TYPE_MAP.adverbs,
  SCORING_TYPE_MAP.grammarIssues,
  SCORING_TYPE_MAP.watchwords,
];

export const ISSUE_TYPE_LABELS = {
  [SCORING_TYPE_MAP.veryLongSentences]: "V. Long Sentences",
  [SCORING_TYPE_MAP.longSentences]: "Long Sentences",
  [SCORING_TYPE_MAP.longWords]: "Long Words",
  [SCORING_TYPE_MAP.passives]: "Passive Voice",
  [SCORING_TYPE_MAP.hiddenVerbs]: "Hidden Verbs",
  [SCORING_TYPE_MAP.adverbs]: "Adverbs",
  [SCORING_TYPE_MAP.grammarIssues]: "Grammar Issues",
  [SCORING_TYPE_MAP.watchwords]: "Watchwords",
};

export const REPHRASE_TYPES = {
  REPHRASE: "REPHRASE",
  SIMPLIFY: "SIMPLIFY",
};

export const CONTENT_REQUIRED_MESSAGE =
  "The document requires content for scoring analysis";

export const NO_CHANGES_MESSAGE = "No changes to analyze";

export const SCORING_NOT_AVAILABLE_ERROR_CODE = "SCORING_NOT_AVAILABLE";

export const ANALYSIS_IN_PROGRESS_LABEL = "Analysis in progress...";
